import { cn } from '@components/shadcn/utils';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { MenuCollapseIcon, MenuIcon } from '../../../assets/icons/minor';
import type { RootState } from '../../../redux/reducers';
import styles from './_sideBarFooter.module.scss';

export const SideBarFooter = () => {
  const { t } = useTranslation();
  const { sidebarCollapsed } = useSelector((state: RootState) => state.App);

  const wrapperStyle = classNames(styles.wrapper, { [styles.expand]: !sidebarCollapsed });

  return (
    <div
      className={cn(wrapperStyle, 'relative')}
      data-testid={`sidebar-footer-${sidebarCollapsed ? 'collapsed' : 'expanded'}`}
    >
      {!sidebarCollapsed && import.meta.env.VITE_APP_VERSION && (
        <p className="absolute bottom-0 left-1 text-[10px] text-sy-neutral-60 font-bold">
          {import.meta.env.VITE_APP_VERSION}
        </p>
      )}
      <div className={styles.container}>
        <div className={styles.wrapperItem}>
          {sidebarCollapsed ? <MenuIcon /> : <MenuCollapseIcon />}
        </div>
        <div className={styles.wrapperItem}>
          <span>{t(`sidebar.trigger_${sidebarCollapsed ? 'open' : 'close'}`)}</span>
        </div>
      </div>
    </div>
  );
};
